import { GetAllBones as u, uuidV4 as h } from "@project-rouge/rg-core";
import { getConnectedBonesAtLevel as m } from "../level-config/index.js";
function I(l, o) {
  if (l.data.levels.length === 0)
    throw new Error("Roof could not be created, Building has no levels!");
  const c = u(l.data.anatomy), d = l.data.levels.sort((t, n) => t.levelIndex - n.levelIndex), s = [], r = [];
  for (const t of c)
    r.includes(t) || r.push(...p(l, t, d, s, o));
  return l.data.levels.push(...s), s;
}
function p(l, o, c, d, s) {
  const r = c.filter((e) => e.bones.includes(o.id)), t = r[r.length - 1];
  let n = m(o, t.levelIndex).filter((e) => e.floors === o.floors);
  const i = o.joints.flatMap((e) => e.bones);
  n.every((e) => e.id === o.id || !i.includes(e)) && (n = [o]);
  const f = l.children.filter((e) => e.data.level === t.levelIndex), v = Math.max(...f.map((e) => e.size[1])) + t.floorWorldBottom, a = {
    uuid: h(),
    levelIndex: t.levelIndex + 1,
    floorWorldBottom: v,
    levelConfig: s,
    isRoof: !0,
    bones: n.map((e) => e.id)
  };
  return d.push(a), [o, ...n];
}
export {
  I as createRoofLevel
};
//# sourceMappingURL=index2.js.map
